import React from 'react'
import { MuiBox, TableConsumer, } from '../../../../components/storybook'
import { useMediaQuery } from '@mui/material'
import { GetThemeColorFromStorage } from '../../../../redux/api/themeColor'
import { getTableColumns } from '../../mocks'

export function Table({
	id,
	history,
	negotiationDetailsTable,
	pointsMask,
	tablePagination,
	getPaginatedNegotiations,
	isLoadingDetailsTable,
}) {
	const matches = useMediaQuery('(max-width:600px)')

	const redirectToDetailPage = (id) => {
		history.push(`/shopHistory/detail/${id}`)
	}

	return (
		<MuiBox
			mt={2}
			sx={{
				overflow: 'auto!important',
				'& .table tr:nth-child(even)': {
					backgroundColor: '#FFFFFF!important',
				},
			}}
		>
			<TableConsumer
				columns={getTableColumns({
					redirectToDetailPage,
					pointsMask,
				})}
				firstItemPadding={
					negotiationDetailsTable?.results?.length
						? '10px 10px!important'
						: '10px 16px!important'
				}
				padding="0px 16px 0px 16px!important"
				notFoundMessage="Não há registros de produtos"
				onChangeRowsPerPage={() => { }}
				showPagination
				loading={isLoadingDetailsTable}
				data={negotiationDetailsTable?.results}
				totalItems={tablePagination?.totalPages}
				defaultRows={10}
				onChangePage={(page) => {
					getPaginatedNegotiations(id, 'page', page, tablePagination)
				}}
				changeRowsPerPage={(rowsPerPage) => {
					getPaginatedNegotiations(
						id,
						'pageSize',
						rowsPerPage,
						tablePagination,
					)
				}}
				overflow={(matches && 'auto') || 'hidden'}
				defaultColor={
					GetThemeColorFromStorage()?.navigation?.buttons
						?.backgroundColor
				}
			/>
		</MuiBox>
	)
}
